import * as PIXI from "pixi.js";
import { ButtonGroup } from "../../control/ButtonGroup";
import { TitanButton } from "../../control/TitanButton";
import { TitanPanel } from "../../control/TitanPanel";
import { FactoryManager } from "../../factory/FactoryManager";
import { AbstractStakeSelector } from "./AbstractStakeSelector";
/**
 * AbstractStakePanel.ts
 */
export class AbstractStakePanel extends AbstractStakeSelector {
    createProperties(uiProperties, portraitProperties) {
        super.createProperties(uiProperties, portraitProperties);
        this.abstractStakePanelProperties = uiProperties;
    }
    updateValues() {
        this.panel.removeAll();
        this.createValueButtons();
        this.createTop(this.panel);
        this.createBottom(this.panel);
        this.createValueHolderMask();
        this.refresh(false);
    }
    create() {
        super.create();
        this.isOpen = false;
        this.createStakePanel();
        this.createPanelSize();
        this.createToggleButton();
    }
    handleNewStakeButtonSelected(button) {
        this.stakeSelectorData.setIndex(button.getData());
        this.refresh(true);
        if (this.abstractStakePanelProperties.closeOnSelection) {
            this.close();
        }
    }
    show() {
        this.visible = true;
    }
    hide() {
        this.visible = false;
        this.disable();
    }
    unhighlightButtons() {
        super.unhighlightButtons();
        this.panel.unhighlightButtons();
    }
    update(stakeSelectorData) {
        super.update(stakeSelectorData);
        this.updateValues();
        this.dispatchChange();
    }
    getToggleButton() {
        return this.toggleButton;
    }
    getPanel() {
        return this.panel;
    }
    open() {
        const model = FactoryManager.getInstance()?.getFactory()?.getModel();
        if (model) {
            model.dispatchKPI("TITAN_STATE", "STAKE_SELECTOR_OPEN", null);
        }
    }
    close() {
        this.unhighlightButtons();
        const model = FactoryManager.getInstance()?.getFactory()?.getModel();
        if (model) {
            model.dispatchKPI("TITAN_STATE", "STAKE_SELECTOR_CLOSE", `${model.getCurrentStake()}`);
        }
    }
    createTop(panel) {
        let top = this.assetManager.getSprite(this.abstractStakePanelProperties.topProperties);
        panel.addToPanelAt(top, 0, false);
    }
    createBottom(panel) {
        let bottom = this.assetManager.getSprite(this.abstractStakePanelProperties.bottomProperties);
        panel.addToPanel(bottom, true);
    }
    createStakePanel() {
        this.panel = new TitanPanel(this.abstractStakePanelProperties.panelProperties);
    }
    createToggleButton() {
        this.toggleButton = new TitanButton(this.abstractStakePanelProperties.toggleButtonProperties);
        this.toggleButton.name = "toggleButton";
        this.toggleButton.onClick(this.handleToggleButtonSelected, this);
        this.addChild(this.toggleButton);
    }
    handleOpenToggleComplete() {
        this.removePanelMask();
    }
    createValueButtons() {
        this.buttonGroup = new ButtonGroup();
        this.valueButtons = [];
        let index = this.stakeSelectorData.getIndex();
        let displayValues = this.stakeSelectorData.getDisplayValues();
        for (let i = 0; i < displayValues.length; i++) {
            this.createValueButton(i, displayValues[i]);
        }
        this.valueButtons[index].setSelected(true);
        this.panel.arrange();
    }
    createValueButton(index, text) {
        let button = new TitanButton(this.abstractStakePanelProperties.valueButtonProperties);
        button.setText(text);
        button.onClick(this.handleNewStakeButtonSelected, this);
        button.setData(index);
        button.accessibleHint = this.abstractStakePanelProperties.valueButtonProperties.accessibleOptions?.accessibleHint ?? text;
        this.panel.addToPanelAt(button, 0, false);
        this.buttonGroup.add(button);
        this.valueButtons.push(button);
    }
    createPanelSize() {
        let container = this.panel.getContainer();
        this.panelSize = new PIXI.Point(container.width, container.height);
        this.createOpenClosePositions();
    }
    addPanelMask() {
        this.panel.mask = this.valueHolderMask;
        this.addChild(this.valueHolderMask);
    }
    removePanelMask() {
        this.panel.mask = null;
        this.removeChild(this.valueHolderMask);
    }
    handleToggleButtonSelected() { }
    createValueHolderMask() { }
    createOpenClosePositions() { }
}
//# sourceMappingURL=AbstractStakePanel.js.map